import React, { Component } from 'react';
import { FormGroup, ControlLabel, Col, FormControl, HelpBlock } from 'react-bootstrap';
import ReactSelect from 'react-select';
import isString from 'lodash/isString';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { ExternalApi } from '../../api';

class OptionComponent extends Component {

	handleMouseDown(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
	}
	
	handleMouseEnter(event) {
		this.props.onFocus(this.props.option, event);
	}
	
	handleMouseMove(event) {
		if (this.props.isFocused) return;
		this.props.onFocus(this.props.option, event);
	}

  render() {
		return (
			<div 
				className={this.props.className}
				onMouseDown={this.handleMouseDown.bind(this)}
				onMouseEnter={this.handleMouseEnter.bind(this)}
				onMouseMove={this.handleMouseMove.bind(this)}
			>
				<i className={`fa fa-${this.props.option.value}`} /> {this.props.children}
			</div>
		);
	}
}

const ValueComponent = (props) => {
  return (
		<div className="Select-value">
			<span className="Select-value-label">
					<i className={`fa fa-${props.value.value}`} /> {props.children}
			</span>
		</div>
  );
};

class IconField extends Component {

	componentDidMount() {
		const { dispatch, fonts } = this.props;
		if (fonts.length === 0) dispatch(ExternalApi.actions.awesomeFonts.get());
  }

	denormalize(value, multiple) {
		if (value.length > 0 && multiple && isString(value[0])) {
			return value.map(v => ({ label: v, value: v }));
		} return value;
	}

	render() {
		const { 
			placeholder, 
			instanceId,
			input,
			meta: { error, touched }, 
			label, 
			id, 
			layout,
			fonts,
			multiple
		} = this.props;

		const showError = error && touched;      

		const selectBlock = () => {
			return (
				<ReactSelect
					instanceId={instanceId || `instanceId-${id || input.name}`}
					name={input.name}
					options={fonts || []} 
					placeholder={placeholder} 
					onChange={input.onChange}
					multi={multiple} 
					value={this.denormalize(input.value, multiple)}
					valueKey='value' 
					labelKey='label'
					optionComponent={OptionComponent}
					valueComponent={ValueComponent}
				/>
			);
		};

		const inputBlock = () => {
			return (
				<div>
					{selectBlock()}
					<FormControl.Feedback />
					<HelpBlock>{showError ? error : ''}</HelpBlock>
				</div>
			);
		};

		if (layout === 'horizontal') {
			return (
				<FormGroup controlId={id || input.name} validationState={showError ? 'error' : null}>
					<Col componentClass={ControlLabel} xs={3} className="control-label-horizontal">
						{label}
					</Col>
					<Col xs={9}>
						{inputBlock()}
					</Col>
				</FormGroup>
			);
		}

		return (	
			<FormGroup 
				controlId={id || input.name} 
				className={label ? 'label-present' : 'label-blank'} 
				validationState={showError ? 'error' : null}
			>	
				{label ? <ControlLabel>{label}</ControlLabel> : ''}
				{inputBlock()}
			</FormGroup>
		);
	}
}

const mapStateToProps = (state) => {
  const { external: { awesomeFonts } } = state;
  const fonts = get(awesomeFonts, 'data.items', []);
  return { fonts };
};

export default connect(mapStateToProps)(IconField);
